import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { useFeatures } from "components/FeatureFlag";

import {
  useAccessTypeStore,
  useWorkDesk,
  useWorkDeskEnabled,
  WithAccessTypeProvider,
} from "./components/hooks";
import HubFeed from "./components/HubFeed";
import WorkspaceContainer from "./Container";
import { HubContextProvider } from "./Provider";

export function Workspace({ hub, advisor }) {
  const { ready, setAccessStatus } = useAccessTypeStore();
  const workDeskEnabled = useWorkDeskEnabled();
  const ffScreenManager = useFeatures("work-desk-screen-manager");
  const { isWorkdeskClientPath } = useWorkDesk();

  // the work-desk screen tops out below the fixed z-102 Hub Feed tab,
  // so the feed slides away while a workdesk route owns the workspace
  const hideHubFeed = Boolean(
    workDeskEnabled && ffScreenManager && isWorkdeskClientPath
  );

  useEffect(() => {
    setAccessStatus(advisor?.role?.title === "Administrator");
  }, [advisor, setAccessStatus]);

  if (!ready) return null;

  return (
    <HubContextProvider
      hubId={hub.id}
      hubShortId={hub.hubId}
      hubClientPoolId={hub.clientPool.id}
      sortByLastName={hub.sortByLastName}
      hubAdvisor={advisor}
      advisors={hub.advisors}
      integration={advisor.integrations.find((i) => {
        return i.hubId === hub.id;
      })}
    >
      <HubFeed hidden={hideHubFeed} />
      <WorkspaceContainer />
    </HubContextProvider>
  );
}

Workspace.propTypes = {
  hub: PropTypes.object.isRequired,
  advisor: PropTypes.object.isRequired,
};

Workspace.defaultProps = {};

export default WithAccessTypeProvider(Workspace);
